import { createRouter, createWebHistory } from "vue-router";
import CompetitionList from "@/views/competition/list/CompetitionList.vue";
import ManageLayout from "@/components/ManageLayout.vue";
import { isLogin } from "@/utils/auth";
import alert from "@/utils/alert";
import useProfileStore from "@/stores/profile-store";

export const routes = [
  { path: "/", name: "competition-list", component: CompetitionList },
  {
    path: "/detail",
    name: "competition-detail",
    component: () => import("@/views/competition/detail/CompetitionDetail.vue"),
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

export const manageRoutes = [
  {
    path: "/manage",
    meta: { title: "赛事管理" },
    component: ManageLayout,
    redirect: "/manage/competition-list",
    children: [
      {
        path: "competition-list",
        name: "manage-competition-list",
        meta: { title: "赛事列表" },
        component: () => import("@/views/manage/competition/list"),
      },
      {
        path: "competition-detail",
        name: "manage-competition-detail",
        meta: { title: "赛事详情", hidden: true },
        component: () => import("@/views/manage/competition/detail"),
      },
      {
        path: "competition-content",
        name: "manage-competition-content",
        meta: { title: "赛事正文", hidden: true },
        component: () => import("@/views/manage/competition/ContentEditor"),
      },
      {
        path: "work-list",
        name: "manage-work-list",
        meta: { title: "赛事作品" },
        component: () => import("@/views/manage/competition/work"),
      },
      // {
      //   path: "participants-list",
      //   name: "manage-participants-list",
      //   meta: { title: "参赛人员" },
      //   component: () => import("@/views/manage/competition/participant"),
      // },
      {
        path: "realname-verify",
        name: "manage-realname-verify",
        meta: { title: "实名认证" },
        component: () => import("@/views/manage/competition/realname-verify"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_ENV === "production" ? "/challenges" : "/"),
  routes: [...routes, ...manageRoutes],
});

// 全局前置路由守卫
router.beforeEach((to, from, next) => {
  // 判断是否需要访问管理后台（以 /manage 开头的路由）
  if (to.path.startsWith("/manage")) {
    const profile = useProfileStore();

    // 检查用户是否已登录
    if (!isLogin() || !profile.isAdmin) {
      alert.warning("请先登录后再访问管理后台");
      // 重定向到首页，可以携带跳转参数
      next({ path: "/", query: { redirect: to.fullPath } });
      return;
    }
  }
  next();
});

export default router;
